import SideMenu from '@/containers/side-menu/SideMenu.vue';
import CashReinforcement from '@/pages/cash-reinforcement/CashReinforcement.vue';

export default {
  path: '/accounting-cash/cash-reinforcement/:userId',
  name: 'CashReinforcement',
  components: {
    mainContent: CashReinforcement,
    mainMenu: SideMenu,
  },
  meta: {
    role: {
      sectorId: 'cash-reinforcement',
    },
    breadcrumb: {
      title: 'Controle de Caixa',
      paths: [{ title: 'Reforço de caixa' }],
    },
  },
};
